/* eslint-disable */
import { Button, Card, Col, Layout, message, Modal, Row, Table, Typography } from 'antd'
import { PropTypes } from 'prop-types'
import React from 'react'
import { useHistory, useParams } from 'react-router'

// Context
import {
  setSearch,
  setFields,
  setIsLoading,
  setSavedSearchVal,
  setSearchApiObj,
  useQueryActions,
  useQuerysDispatch,
  useQuerysState
} from '../../CandidateContext/SearchQueryContext'
// Table Columns
import CreateModal from '../../components/modalBodyComponent/CreateModal'
import FilteredDataColumns from './FilteredDataColumns'

const { Content } = Layout
const { Title } = Typography

export default function FilteredData({ extra }) {
  const { jobkey } = useParams()
  const history = useHistory()
  const [urlVal, setUrlVal] = React.useState(false)
  const [jobVal, setJobVal] = React.useState(null)
  const [values, setValues] = React.useState({
    name: ''
  })
  // Context
  const { searchedCandidates, isLoading, SelectedCandidates, savedSearchVal, searchApiObj } =
    useQuerysState()
  const dispatch = useQuerysDispatch()
  const actions = useQueryActions()

  // Hooks
  const { columns } = React.useMemo(
    () => FilteredDataColumns(searchedCandidates),
    [searchedCandidates]
  )
  React.useEffect(() => dispatch(setFields({ SelectedCandidates: [] })), [])

  const SearchedCandidatesTable = () => {
    const rowSelection = {
      selectedRowKeys: SelectedCandidates,
      selection: SelectedCandidates,
      onSelect: (candidate) => {
        const checkCandidate = () => {
          if (SelectedCandidates.includes(candidate.id)) {
            return SelectedCandidates.filter((id) => id !== candidate.id)
          }
          return [...(SelectedCandidates || []), candidate.id]
        }
        dispatch(setFields({ SelectedCandidates: checkCandidate() }))
      },
      onSelectAll: () => {
        if (SelectedCandidates.length === searchedCandidates?.results.length) {
          dispatch(setFields({ SelectedCandidates: [] }))
        } else {
          dispatch(
            setFields({ SelectedCandidates: searchedCandidates?.results.map((item) => item.id) })
          )
        }
      }
    }

    const savedMessage = () => message.success('Your search is saved')
    const createDiscoverJob = async () => {
      dispatch(setIsLoading(true))
      try {
        const obj = {
          annotations: {
            ...searchApiObj,
            mustHave: {
              ...searchApiObj.mustHave
            },
            shouldHave: { ...searchApiObj.shouldHave },
            mustNotHave: { ...searchApiObj.mustNotHave }
          },
          name: values.name,
          locations: searchApiObj.mustHave.locations,
          title: '',
          country: '',
          description: 'job Description',
          region: '',
          status: 'open'
        }

        const job = await actions.createJob(obj)
        if (!job) return
        setJobVal(job)
        savedMessage()
        dispatch(setSearchApiObj({ ...obj.annotations }))
        dispatch(setSavedSearchVal(false))
      } catch (e) {
        dispatch(setIsLoading(false))
        console.log(e.message)
      } finally {
        dispatch(
          setSearchApiObj({
            ...searchApiObj,
            mustHave: {
              ...searchApiObj.mustHave,
              career_count: '',
              career_length: ''
            }
          })
        )
        dispatch(setIsLoading(false))
        setUrlVal(true)
      }
    }

    function handleOk() {
      createDiscoverJob()
    }

    const handleInputChange = (e) => {
      setValues({ ...values, [e.target.name]: e.target.value })
    }

    React.useEffect(() => {
      if (urlVal) {
        history.push(`/candidates/${jobVal?.jobKey}`)
      }
    }, [urlVal])

    return (
      <Col className="table-parent-col">
        <Card style={{ minHeight: 'calc(100vh - 200px)' }}>
          <div className="passive-table-header">
            <div>
              <span>Passive Candidates</span>
            </div>
            <div>{extra}</div>
          </div>
          <Table
            rowSelection={{
              ...rowSelection
            }}
            rowKey={'id'}
            columns={columns}
            dataSource={searchedCandidates?.results || []}
            className="filtered-data-table"
            loading={isLoading}
            scroll={searchedCandidates?.results?.length ? { y: 'calc(100vh - 400px)' } : {}}
            onChange={(pagination) => {
              window?.analytics?.track('Page change', {
                page: pagination?.current,
                search_id: jobkey
              })
            }}
          />
        </Card>
        <Row justify="space-between" align="center" className="best-matches">
          <Typography>
            <Title level={5}> {searchedCandidates?.results?.length || 0} Matching Result</Title>
          </Typography>
        </Row>
        <Modal
          className="discover-modal"
          centered
          closable={false}
          visible={savedSearchVal}
          footer={[
            <Button
              disabled={isLoading}
              key="cancel"
              onClick={() => dispatch(setSavedSearchVal(false))}
            >
              Cancel
            </Button>,
            <Button loading={isLoading} type="primary" key="Save" onClick={() => handleOk()}>
              Save
            </Button>
          ]}
        >
          <CreateModal
            values={values}
            handleSubmit={handleOk}
            handleInputChange={handleInputChange}
          />
        </Modal>
      </Col>
    )
  }

  return <Content style={{ height: 'calc(100vh - 200px)' }}>{SearchedCandidatesTable()}</Content>
}
FilteredData.propTypes = {
  extra: PropTypes.object,
  advancedSearchVal: PropTypes.bool
}
